import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { HomeGuard } from './guard/home.guard';
import { LoginGuard } from './guard/login.guard';
import { ScGuard } from './guard/sc.guard';
import { KontoComponent } from './konto/konto.component';
import { OcLayoutBlankComponent } from './layout/oc-layout-blank/oc-layout-blank.component';
import { OCLayout } from './layout/oc-layout/oc-layout.component';
import { LoginComponent } from './login/login.component';
import { DummySiteComponent } from './mwsp/dummy-site/dummy-site.component';
import { SystemconfigComponent } from './systemconfig/systemconfig.component';

const routes: Routes = [
    {
        path: '',
        component: OcLayoutBlankComponent,
        pathMatch: 'full',
        canActivate: [HomeGuard],
        children: [{ path: '', component: LoginComponent }],
    },
    {
        path: 'dummy',
        component: DummySiteComponent,
    },
    {
        path: 'print',
        component: OcLayoutBlankComponent,
        canActivate: [LoginGuard],
        loadChildren: () => import('./print/print.module').then((m) => m.PrintModule),
    },
    {
        path: 'konto',
        component: OCLayout,
        canActivate: [LoginGuard],
        children: [{ path: '', component: KontoComponent }],
    },
    {
        path: 'systemconfiguration',
        component: SystemconfigComponent,
        canActivate: [ScGuard],
    },
    {
        path: 'mwsp',
        component: OCLayout,
        canActivate: [LoginGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./mwsp/mwsp.module').then((m) => m.MwspModule),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: 'reload',
            useHash: true,
            // preloadingStrategy: PreloadAllModules, TODO: Ladezeiten im Safari Browser und Firefox Browser sind zu lang, wenn PreloadAllModules aktiviert ist!
            bindToComponentInputs: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
